<template>
  <b-card no-body>
    <b-card-header>
      <h4>{{ $t('bookings.rejected_assignments') }}</h4>
    </b-card-header>

    <b-card-body>
      <b-table :items="assignments" :fields="fields" responsive> </b-table>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'RejectedAssignments',

  props: {
    assignments: {
      type: Array,
      required: true,
    },
  },

  computed: {
    fields() {
      return [
        {
          key: 'company_name',
          label: this.$t('bookings.company'),
        },
        {
          key: 'reason',
          label: this.$t('bookings.reject_reason'),
        },
      ]
    },
  },
}
</script>
